/**
 * @generated SignedSource<<db9ad710ca255d5488384312589ce190>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type MATOrganizationPlanEnum = "enterprise" | "free" | "team" | "%future added value";
export type MATOrganizationPremiumTypeEnum = "premium_non_refundable" | "premium_refundable" | "%future added value";
export type MATInvoiceUpdateInput = {
  amount?: number | null;
  description?: string | null;
  endDate?: any | null;
  id: string;
  isMonthlyPaid?: boolean | null;
  maxStudentCount?: number | null;
  plan?: MATOrganizationPlanEnum | null;
  premiumType?: MATOrganizationPremiumTypeEnum | null;
  scholarshipAmount?: number | null;
  startDate?: any | null;
  title?: string | null;
};
export type MATInvoiceUpdateDialog_invoiceUpdateMutation$variables = {
  input: MATInvoiceUpdateInput;
};
export type MATInvoiceUpdateDialog_invoiceUpdateMutation$data = {
  readonly invoiceUpdate: {
    readonly amount: number;
    readonly endDate: any;
    readonly id: string;
    readonly isMonthlyPaid: boolean;
    readonly maxStudentCount: number;
    readonly plan: MATOrganizationPlanEnum;
    readonly premiumType: MATOrganizationPremiumTypeEnum;
    readonly scholarshipAmount: number | null;
    readonly startDate: any;
    readonly title: string;
  };
};
export type MATInvoiceUpdateDialog_invoiceUpdateMutation = {
  response: MATInvoiceUpdateDialog_invoiceUpdateMutation$data;
  variables: MATInvoiceUpdateDialog_invoiceUpdateMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "MATInvoice",
    "kind": "LinkedField",
    "name": "invoiceUpdate",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "title",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "premiumType",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "scholarshipAmount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "startDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "endDate",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "maxStudentCount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amount",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "plan",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "isMonthlyPaid",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "MATInvoiceUpdateDialog_invoiceUpdateMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "MATInvoiceUpdateDialog_invoiceUpdateMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e790135873f7ebf51f4139542348c2bb",
    "id": null,
    "metadata": {},
    "name": "MATInvoiceUpdateDialog_invoiceUpdateMutation",
    "operationKind": "mutation",
    "text": "mutation MATInvoiceUpdateDialog_invoiceUpdateMutation(\n  $input: MATInvoiceUpdateInput!\n) {\n  invoiceUpdate(input: $input) {\n    id\n    title\n    premiumType\n    scholarshipAmount\n    startDate\n    endDate\n    maxStudentCount\n    amount\n    plan\n    isMonthlyPaid\n  }\n}\n"
  }
};
})();

(node as any).hash = "86b8d5dc454bf6dee50201eef281d673";

export default node;
